import React from 'react';
import { Target, Eye, TrendingUp } from 'lucide-react';
import { companyData } from '../mock';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            About <span className="text-blue-600">Unified Power</span>
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Leading the power sector with {new Date().getFullYear() - parseInt(companyData.established)} years of experience in power plant engineering
          </p>
        </div>

        {/* Company Overview */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <div className="mb-6">
              <span className="inline-block px-4 py-1 bg-blue-100 text-blue-600 text-sm font-semibold rounded-full mb-4">
                Established {companyData.established}
              </span>
              <h3 className="text-3xl font-bold text-slate-800 mb-4">Our Story</h3>
              <p className="text-slate-600 leading-relaxed">
                {companyData.about}
              </p>
            </div>

            {/* Priorities */}
            <div className="space-y-3">
              <h4 className="text-xl font-semibold text-slate-800 mb-4">Our Priorities</h4>
              {companyData.priorities.map((priority, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  <span className="text-slate-700">{priority}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1578776349090-de61da00ff1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHx0aGVybWFsJTIwcG93ZXIlMjBwbGFudHxlbnwwfHx8fDE3NjQ4NTU3NzF8MA&ixlib=rb-4.1.0&q=85"
              alt="Industrial Facility"
              className="rounded-lg shadow-2xl w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-8 rounded-lg shadow-xl">
              <div className="text-4xl font-bold mb-1">{new Date().getFullYear() - parseInt(companyData.established)}+</div>
              <div className="text-sm">Years of Excellence</div>
            </div>
          </div>
        </div>

        {/* Vision & Mission */}
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-xl p-8 shadow-lg border-t-4 border-blue-600">
            <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-6">
              <Eye className="w-7 h-7 text-blue-600" />
            </div>
            <h3 className="text-2xl font-bold text-slate-800 mb-4">Our Vision</h3>
            <p className="text-slate-600 leading-relaxed">
              {companyData.vision}
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg border-t-4 border-slate-700">
            <div className="w-14 h-14 bg-slate-100 rounded-full flex items-center justify-center mb-6">
              <Target className="w-7 h-7 text-slate-700" />
            </div>
            <h3 className="text-2xl font-bold text-slate-800 mb-4">Our Mission</h3>
            <p className="text-slate-600 leading-relaxed">
              {companyData.mission}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
